module.exports = __webpack_public_path__ + "static/media/hexlogo.3ef2db92.svg";